var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFuelTank = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 0.3,
  d: "M13.775 4.391h-1.366v-.958c0-.87-.682-1.583-1.528-1.583H7.796c-.852 0-1.528.718-1.528 1.583v.954H5.4a.56.56 0 0 0-.551.567v15.629c0 .309.24.567.551.567h13.095a.56.56 0 0 0 .552-.567V9.573a.58.58 0 0 0-.17-.413l-.702-.686.835-.974a.58.58 0 0 0-.036-.79l-2.282-2.197a.537.537 0 0 0-.783.03v.001l-.822.912-.932-.91a.54.54 0 0 0-.381-.155zm2.116 1.845.45-.505 1.486 1.436-.442.518-1.494-1.45zM7.37 3.433c0-.252.196-.448.425-.448h3.09c.228 0 .425.196.425.448v.954H7.37zm10.574 16.578H5.953V5.517h7.604l4.388 4.295v10.199z"
})));
export default SvgFuelTank;